﻿(function () {
  'use strict';
  if (!window.__curseHkAlertPatch) {
    window.__curseHkAlertPatch = true;
    var nativeAlert = window.alert;
    window.alert = function (msg) {
      if (msg && String(msg).toLowerCase().indexOf('line parametre') !== -1) return;
      if (msg && String(msg).toLowerCase().indexOf('line parameter') !== -1) return;
      return nativeAlert.apply(window, arguments);
    };
  }
  if (window.__curseHkLegacyBlock) return;
  window.__curseHkLegacyBlock = true;
  var nativeAdd = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function (type, listener, options) {
    if (type === 'click' && listener) {
      var src = Function.prototype.toString.call(listener);
      if (src.indexOf('lineIndexesForSet') !== -1) return;
      if (
        src.indexOf('data-curse-hk-set-remove') !== -1 &&
        src.indexOf('postCartUpdate') === -1 &&
        (src.indexOf('changeCartLine') !== -1 || src.indexOf('cart/change.js') !== -1)
      ) {
        return;
      }
    }
    return nativeAdd.call(this, type, listener, options);
  };
})();

(function () {
  'use strict';
  if (window.__curseHkSetCartBound) return;
  window.__curseHkSetCartBound = true;

  var removeInFlight = Object.create(null);

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function hkSetIdFromItem(item) {
    if (!item || !item.properties) return '';
    var p = item.properties;
    if (Array.isArray(p)) {
      for (var i = 0; i < p.length; i++) {
        var row = p[i];
        if (!row) continue;
        var n = row.name || row.first || row.key;
        if (n === 'curse_hk_set' || n === '_curse_hk_set') {
          var val = row.value || row.last;
          if (val) return String(val).trim();
        }
      }
      return '';
    }
    var direct =
      p.curse_hk_set ||
      p['curse_hk_set'] ||
      p._curse_hk_set ||
      p['_curse_hk_set'] ||
      '';
    if (direct) return String(direct).trim();
    var keys = Object.keys(p);
    for (var k = 0; k < keys.length; k++) {
      var key = keys[k];
      if (key === 'curse_hk_set' || key === '_curse_hk_set') {
        var v = p[key];
        if (v) return String(v).trim();
      }
    }
    return '';
  }

  function rootForSet(setId) {
    var esc = String(setId).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    return document.querySelector('[data-curse-hk-set="' + esc + '"]');
  }

  function domKeysForSet(setId) {
    var root = rootForSet(setId);
    if (!root) return [];
    var raw = root.getAttribute('data-curse-hk-keys') || '';
    return raw
      .split(',')
      .map(function (x) {
        return x.trim();
      })
      .filter(Boolean);
  }

  function itemInSet(item, setId, domKeySet) {
    if (!item) return false;
    if (hkSetIdFromItem(item) === setId) return true;
    if (domKeySet && item.key && domKeySet[item.key]) return true;
    return false;
  }

  function collectSetItems(cart, setId) {
    var domKeys = domKeysForSet(setId);
    var domKeySet = Object.create(null);
    domKeys.forEach(function (k) {
      domKeySet[k] = true;
    });
    var list = [];
    cart.items.forEach(function (item) {
      if (itemInSet(item, setId, domKeySet)) list.push(item);
    });
    return list;
  }

  async function refreshDrawer(lastState) {
    var drawer = getDrawer();
    if (!drawer) {
      window.location.reload();
      return;
    }
    if (lastState && lastState.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(lastState);
      if (typeof drawer.open === 'function') drawer.open();
      return;
    }
    try {
      var cart = await fetch('/cart.js').then(function (r) {
        return r.json();
      });
      var secRes = await fetch(
        window.location.pathname + '?sections=cart-drawer,cart-icon-bubble'
      );
      var sections = await secRes.json();
      if (typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections: sections, item_count: cart.item_count });
      } else if (typeof drawer.updateCartContent === 'function') {
        await drawer.updateCartContent();
      }
      if (typeof drawer.open === 'function') drawer.open();
    } catch (e) {
      window.location.reload();
    }
  }

  async function postCartUpdate(body) {
    var r = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });
    var data = await r.json();
    if (!r.ok || data.status === 422) {
      throw new Error(data.description || data.message || 'Güncellenemedi');
    }
    return data;
  }

  function updatesForItems(items, qty) {
    var updates = Object.create(null);
    items.forEach(function (item) {
      if (item && item.variant_id != null) {
        updates[String(item.variant_id)] = qty;
      }
    });
    return updates;
  }

  async function removeSet(setId) {
    setId = String(setId || '').trim();
    if (!setId) return;
    if (removeInFlight[setId]) return removeInFlight[setId];

    removeInFlight[setId] = (async function () {
      try {
        var cart = await fetch('/cart.js').then(function (r) {
          return r.json();
        });
        var items = collectSetItems(cart, setId);
        if (!items.length) {
          await refreshDrawer(null);
          return;
        }
        var lastState = await postCartUpdate({
          updates: updatesForItems(items, 0),
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        });
        await refreshDrawer(lastState);
      } finally {
        delete removeInFlight[setId];
      }
    })();
    return removeInFlight[setId];
  }

  async function deltaSet(setId, delta) {
    setId = String(setId || '').trim();
    var cart = await fetch('/cart.js').then(function (r) {
      return r.json();
    });
    var items = collectSetItems(cart, setId);
    if (!items.length) return;
    var next = items[0].quantity + delta;
    if (next <= 0) {
      await removeSet(setId);
      return;
    }
    var lastState = await postCartUpdate({
      updates: updatesForItems(items, next),
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });
    await refreshDrawer(lastState);
  }

  document.addEventListener(
    'click',
    function (e) {
      var rm = e.target.closest('[data-curse-hk-set-remove]');
      if (rm) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (rm.dataset.curseHkBusy === '1') return;
        rm.dataset.curseHkBusy = '1';
        var id = rm.getAttribute('data-set-id');
        var root = rm.closest('[data-curse-hk-set]');
        if (!id && root) id = root.getAttribute('data-curse-hk-set');
        if (id) {
          removeSet(id).finally(function () {
            delete rm.dataset.curseHkBusy;
          });
        } else {
          delete rm.dataset.curseHkBusy;
        }
        return;
      }
      var deltaBtn = e.target.closest('[data-curse-hk-set-delta]');
      if (!deltaBtn) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var setId = deltaBtn.getAttribute('data-set-id');
      var d = Number(deltaBtn.getAttribute('data-curse-hk-set-delta')) || 0;
      if (setId && d) deltaSet(setId, d);
    },
    true
  );
})();
